import React from "react";
import { Link } from "react-router-dom";

const DiscoverMasterpiece = () => {
  return (
    <div className="w-full bg-[#fcf9f2] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between bg-white shadow-lg overflow-hidden border border-[#eae0d5]">
          
          {/* Left Text Content */}
          <div className="w-full md:w-1/2 p-10 lg:p-16 flex flex-col justify-center items-start">
            <h2 className="text-3xl md:text-5xl font-serif text-[#D4AF37] mb-6 leading-tight">
              Discover Your <br />
              <span className="text-[#3B291A]">Unique Masterpiece</span>
            </h2>
            <p className="text-gray-600 text-base md:text-lg mb-8 leading-relaxed">
              As unique and special as you are. Each design is crafted with precision, 
              passion, and an unyielding commitment to excellence, tailored just for you.
            </p>
            <Link 
              to="/shop" 
              className="bg-[#D4AF37] hover:bg-[#B8982D] text-black font-bold py-3 px-8 uppercase tracking-widest text-sm transition-colors shadow-md hover:shadow-lg"
            >
              Shop Now
            </Link>
          </div>

          {/* Right Image */}
          <div className="w-full md:w-1/2 h-[400px] md:h-[500px] lg:h-[600px] relative">
            <img 
              src="https://images.unsplash.com/photo-1599643477877-530eb83abc8e?auto=format&fit=crop&q=80&w=1000" 
              alt="Discover Masterpiece" 
              className="w-full h-full object-cover"
            />
            {/* Subtle dark overlay for premium feel */}
            <div className="absolute inset-0 bg-black/10 mix-blend-overlay"></div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default DiscoverMasterpiece;
